import {useState, useMemo, useEffect} from 'react';

import {useHelpBundle} from '@plasma/ui.application.app';
import {useResourceBundle, useTranslation} from '@plasma/ui.utils.i18n';

import {fetchAllDataGet_byApiName} from '../../services/gets/getdata';
import ExportUserColumns, { UsersDataType } from '../../types/usersDataType';
import translations from './i18n';
import {UsersPageProps} from './users-page';
import help from './users-page.help';

function useUsersPageHook(props : UsersPageProps) {
    useResourceBundle(translations, undefined, '1a9244c3-4713-45bb-88a5-e5e67688898f');
    useHelpBundle(help);

    const {t} = useTranslation();

    const [columnNames,setcolumnNames] = useState(ExportUserColumns());
    const [dataForColumns,setdataForColumns] = useState();
    const [dataWithUseMemo, setdataWithUseMemo] = useState([]);

    const username = sessionStorage.getItem('username');
    const token = sessionStorage.getItem('token');
    const company = sessionStorage.getItem('company');


    useEffect(() => {
      // console.log(username, company);
      fetchAllDataGet_byApiName("GetUsers").then((dataFromApi) => {
        setdataForColumns(dataFromApi);
      }).catch((error)=>{
         console.log("Failed to Fetch users");
      });
    }, []);

  const displayDataForColumns = useMemo<UsersDataType[]>(() => {
    let formattedData: UsersDataType[] = [];
    if (dataForColumns) {
      formattedData = dataForColumns?.map((apiData: UsersDataType) => ({
        companyid: apiData.companyid,
        username: apiData.username,
        contactno: apiData.contactno,
        email: apiData.email,
        employeeid: apiData.employeeid,
        groupid: apiData.groupid,
        id: apiData.id,
        isactive: apiData.isactive,
        mop: apiData.mop,
        remarks: apiData.remarks,
        resetpassword: apiData.resetpassword,
        roleid: apiData.roleid,
        toc: apiData.toc,
        tom: apiData.tom,
      }));
    }
    return formattedData;
  }, [dataForColumns]);

  return {
    t,
    columnNames,
    displayDataForColumns,
    isLoading: dataForColumns === undefined,
  };
}

export default useUsersPageHook;
